<template>
  <div class="sample_card__container col-md-6 col-xl-5">
    <div class="card__head fs-w">{{ cardInfo.sampleStyleNo }}</div>
    <div class="card__body">
      <div class="img__container">
        <el-image
          :src="cardInfo.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            cardInfo.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width: 99px; height: 65px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 99px; height: 65px"
            />
          </div>
        </el-image>
      </div>
      <div class="sample-base__container">
        <div class="color-info smc_name">
          {{ cardInfo.sampleSpecName || '' }}
        </div>
        <div class="number-fty__price">
          <div>
            <span class="label-key"
              >{{ $l('form_label_qty') || '数量' }}：</span
            >
            <span class="fs-18 color-info"> {{ cardInfo.qty || 0 }}</span>
          </div>
          <div>
            <span class="label-key"
              >{{ $l('form_label_ftyPrice') || '工厂报价' }}：</span
            >
            <span class="fs-18 fs-600w color-blue mr-3px">{{
              cardInfo.ftyPrice
            }}</span>
            <span class="fs-12 color-info">{{
              cardInfo.ftyCurrencyUnit || ''
            }}</span>
          </div>
        </div>
        <div class="fs-w smc_name">
          <span> {{ cardInfo.scmName || '' }}</span>
        </div>
      </div>
    </div>
    <div class="card__footer">
      <div>
        <span class="fs-w"
          >{{ $l('form_label_deliveryDate') || '发出日期' }}：</span
        >
        <span class="fs-w" style="color: #101010">{{
          deliveryDate || ''
        }}</span>
      </div>
      <div>
        <span class="fs-w"
          >{{ $l('form_label_signDate') || '签收日期' }}：</span
        >
        <span class="fs-w" style="color: #101010">{{ signDate || '' }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cardInfo: { type: Object, default: () => {} },
    deliveryDate: { type: String, default: '' },
    signDate: { type: String, default: '' },
  },
}
</script>
<style lang="scss" scoped>
.sample_card__container {
  max-width: 413px;
  min-width: 350px;
  height: 170px;
  margin-bottom: 10px;
  margin-left: 10px;
  border-radius: 5px;
  background-color: #ffffff;
  .card__head {
    border-radius: 5px 5px 0px 0px;
    background-color: #f9f9f9;
    height: 30px;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }
  .card__body {
    height: calc(100% - 64px);
    padding: 10px;
    display: flex;
    .img__container {
      border-radius: 5px;
      margin-right: 10px;
      .el-image {
        border-radius: 5px;
      }
    }
    .sample-base__container {
      display: flex;
      flex: 1;
      flex-direction: column;
      .color-info {
        color: #101010;
        font-weight: 600;
      }
      .number-fty__price {
        display: flex;
        justify-content: space-between;
      }
      .smc_name {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
  .card__footer {
    height: 22px;
    margin-bottom: 12px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
  }
}

.fs-w {
  color: #4f4f4f;
  font-weight: 600;
  font-size: 14px;
}
.color-4f {
  color: #4f4f4f;
}
.mb-5px {
  margin-bottom: 5px;
}
.mb-10px {
  margin-bottom: 10px;
}
.mr-3px {
  margin-right: 3px;
}
.pb-20px {
  padding-bottom: 20px;
}
.label-key {
  color: #6c757d;
  font-weight: 600;
}
.fs-18 {
  font-size: 18px;
}
.color-blue {
  color: #007bff;
}
.fs-12 {
  font-size: 12px;
}
.fs-600w {
  font-weight: 600;
}
@media screen and (min-width: 768px) {
  .col-md-6 {
    flex: 0 0 50%;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
@media screen and (min-width: 1200px) {
  .col-xl-5 {
    flex: 0 0 41.666667%;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
</style>
